exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-hbt-booking[data-v-7a38c123]{display:flex;padding:24px 32px;justify-content:space-between;align-items:center;align-self:stretch;border-radius:0 0 4px 4px;border:1px solid #dcdcdc;border-top:none;background:#f5f9fc}.separator-space[data-v-7a38c123]{height:16px;background-color:#fff;width:100%}@media(max-width:600px){.wrap-hbt-booking[data-v-7a38c123]{border:0;padding:0;flex-direction:column-reverse}}", ""]);

// exports
